<app-menu></app-menu>

<div class="hero">
    <div class="container-hero">
        <div class="row" style="margin-top: 0px;">
            <div class="col-sm-12 col-md-6">
                <div class="vertical-aling-out">
                    <div class="vertical-aling-inner">
                        <h1><span class="gren">Aqui você </span>publica!</h1>
                        <button class="hero-btn" (click)="scrollToPublish()">Publicar meu livro agora</button>
                    </div>
                </div>
            </div>
            <div class="col-6 d-none d-sm-none d-md-block">
                <img src="assets/images/hero-image.png">
            </div>
        </div>

    </div>
</div>

<div class="book-section">
    <div class="container">
        <h2 class="section-title">Livros mais buscados</h2>

        <div class="slider-container">
            <button class="nav-arrow prev" (click)="scroll('prev', 'mostSearched')"
                [disabled]="sliderStates.mostSearched.disablePrev">
                &#10094;
            </button>

            <div #mostSearchedContainer class="slider-viewport" (scroll)="checkScroll('mostSearched')">
                <div class="books-wrapper">
                    @if(_homeResponse && _homeResponse.mostSearched){
                    @for (item of _homeResponse.mostSearched; track $index) {
                    <a class="book-card"
                        routerLink="/livro/{{item.idKit}}/{{this.utilService.createSlug(item.bookTitle)}}">
                        <div class="book-cover">
                            @if(item.coverUrl){
                            <img src="{{item.coverUrl}}" alt="Capa {{item.bookTitle}}">
                            } @else {
                            <img src="https://placehold.co/150x220/e0e0e0/333?text={{item.bookTitle}}"
                                alt="Capa {{item.bookTitle}}"
                                onerror="this.onerror=null;this.src='https://placehold.co/150x220/e0e0e0/333?text=Imagem+Indisponível';">
                            }
                        </div>
                        <div class="book-title">{{item.bookTitle}}</div>
                    </a>
                    }
                    }
                </div>
            </div>

            <button class="nav-arrow next" (click)="scroll('next', 'mostSearched')"
                [disabled]="sliderStates.mostSearched.disableNext">
                &#10095;
            </button>
        </div>
    </div>
</div>

<!-- Separador visual -->
<div class="section-divider">
    <div class="section-divider-line"></div>
</div>

<!-- Seção de vídeo -->
<div class="video-section">
    <div class="container text-center">
        <h2 class="section-title">Conheça a Feira do Livro</h2>
        <p class="video-subtitle">Assista ao vídeo e descubra como a Feira do Livro pode transformar sua pesquisa, tese,
            dissertação, TCC ou obra acadêmica em um livro profissional publicado.</p>
        <div class="video-wrapper">
            <iframe src="https://www.youtube.com/embed/UYi2-4HfciI" title="Feira do Livro - Conheça nossa história"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
            </iframe>
        </div>
    </div>
</div>

<div class="simulator-banner-wrapper">
    <div class="container">
        <div class="simulator-banner">
            <div class="simulator-banner-content">
                <h3>Descubra o potencial do seu livro!</h3>
                <p>Use nosso simulador gratuito para descobrir seus custos de impressão e o lucro estimado em segundos.
                </p>
                <a routerLink="/simular" class="btn-simulate">Simule grátis agora</a>
            </div>
            <div class="simulator-banner-image d-none d-md-flex">
                <mat-icon>calculate</mat-icon>
            </div>
        </div>
    </div>
</div>

<div class="publish-section" id="publish-section">
    <div class="container">
        <div class="publish-card">
            <div class="publish-card-content">
                <div class="publish-text-side">
                    <p class="publish-eyebrow">⭐ Mais Pontos no Lattes</p>

                    <span
                        style="display: inline-block; margin-bottom: 15px; font-size: 1.1rem; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: #4a5e3e;">COMBO
                        EBOOK + POD</span>

                    <p class="publish-description">
                        Versão <strong>digital</strong> e <strong>impressão sob demanda</strong> - POD. Seu livro existe
                        no digital e pode ser comprado impresso por qualquer pessoa, sem estoque.
                    </p>

                    <p class="publish-ideal"><em>Ideal para quem quer máxima visibilidade e pontuação completa no
                            Lattes.</em></p>

                    <div class="publish-price-row">
                        <span class="publish-price-label">10x</span>
                        <span class="publish-price-value">R$ 550,00</span>
                    </div>
                    <p class="publish-price-method">Cartão de Crédito</p>
                </div>

                <div class="publish-image-side">
                    <img src="assets/images/pagina_inicial.png" alt="Livros EBOOK e POD">
                </div>
            </div>
            <div
                style="text-align: center; padding-top: 40px; padding-bottom: 0px; clear: both; position: relative; z-index: 10;">
                <a href="https://www.feiradolivro.com.br/feiradolivro-ab" target="_blank" rel="noopener noreferrer"
                    class="publish-cta-btn" style="display: inline-block;">Quero publicar meu livro</a>
            </div>
        </div>
    </div>
</div>

<div class="container book-section">
    <h2 class="section-title">Livros mais vendidos</h2>

    <div class="slider-container">
        <button class="nav-arrow prev" (click)="scroll('prev', 'mostSold')"
            [disabled]="sliderStates.mostSold.disablePrev">
            &#10094;
        </button>

        <div #mostSoldContainer class="slider-viewport" (scroll)="checkScroll('mostSold')">
            <div class="books-wrapper">
                @if(_homeResponse && _homeResponse.bestSellers){
                @for (item of _homeResponse.bestSellers; track $index) {
                <a class="book-card" routerLink="/livro/{{item.idKit}}/{{this.utilService.createSlug(item.bookTitle)}}">
                    <div class="book-cover">
                        @if(item.coverUrl){
                        <img src="{{item.coverUrl}}" alt="Capa {{item.bookTitle}}">
                        } @else {
                        <img src="https://placehold.co/150x220/e0e0e0/333?text={{item.bookTitle}}"
                            alt="Capa {{item.bookTitle}}"
                            onerror="this.onerror=null;this.src='https://placehold.co/150x220/e0e0e0/333?text=Imagem+Indisponível';">
                        }
                    </div>
                    <div class="book-title">{{item.bookTitle}}</div>
                </a>
                }
                }
            </div>
        </div>

        <button class="nav-arrow next" (click)="scroll('next', 'mostSold')"
            [disabled]="sliderStates.mostSold.disableNext">
            &#10095;
        </button>
    </div>
</div>

<!-- Seção Acervo Completo -->
<div class="catalog-section">
    <div class="container">
        <div class="catalog-banner">
            <div class="catalog-content">
                <p class="catalog-eyebrow">📚 Acervo completo</p>
                <h3>Isso é só uma <em>amostra</em> do nosso acervo!</h3>
                <p class="catalog-text">Autores de todo o Brasil já publicaram seus livros na Feira do Livro — e o
                    catálogo cresce toda semana. Navegue por todas as obras publicadas e encontre sua próxima leitura.
                </p>
                <a routerLink="/livros" class="btn-catalog">Ver todos os livros <span
                        class="catalog-arrow">&#8594;</span></a>
            </div>
            @if(catalogPreview.length){
            <a routerLink="/livros" class="catalog-covers" aria-label="Ver todos os livros publicados">
                @for (item of catalogPreview; track $index) {
                <img class="fan-cover" src="{{item.coverUrl}}" alt="Capa {{item.bookTitle}}">
                }
                <span class="catalog-more-chip">+ muitos outros</span>
            </a>
            }
        </div>
    </div>
</div>

<app-footer></app-footer>